import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_LOCALE_ROOT } from "./constants";

interface PlanTrialCardProps {
  className?: string;
  planName?: string;
}

export const PlanTrialCard = ({
  planName,
  className = "",
}: PlanTrialCardProps) => (
  <div
    className={`bg-primary border-primary rounded-xl border p-4 ${className}`}
  >
    <div className="mb-1 flex items-center justify-between">
      <div className="text-white">
        <Typography.LabelLg weight="semibold">
          {planName || t(`${I18N_LOCALE_ROOT}.default_plan_name`)}
        </Typography.LabelLg>
      </div>
      <div className="flex flex-row items-center gap-1 align-middle">
        <div className="text-white">
          <Typography.LabelMd weight="bold">
            {t(`${I18N_LOCALE_ROOT}.plan_card.price`)}
          </Typography.LabelMd>
        </div>
      </div>
    </div>
    <div className="text-white/70">
      <Typography.LabelXs>
        {t(`${I18N_LOCALE_ROOT}.plan_card.trial_period`)}
      </Typography.LabelXs>
    </div>
  </div>
);
